// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.env-input {
  background: #fff;
  text-align: center;
  width: 100%;
  margin-left: 0;
}

ion-grid {
  background: #041825;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #fff;
  justify-content: center;
  row-gap: 10px;
}

.logo-container {
  display: flex;
  justify-content: space-around;
  width: 100%;
  padding: 10px 0px;
}
.logo-container img {
  height: 3rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/app-restricted/app-restricted.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AACJ;;AAEA;EACI,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;AACJ;;AAEA;EACI,aAAA;EACA,6BAAA;EACA,WAAA;EACA,iBAAA;AACJ;AAAI;EACI,uBAAA;AAER","sourcesContent":[".env-input {\r\n    background: #fff;\r\n    text-align: center;\r\n    width: 100%;\r\n    margin-left: 0;\r\n}\r\n\r\nion-grid {\r\n    background: #041825;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    color: #fff;\r\n    justify-content: center;\r\n    row-gap: 10px;\r\n}\r\n\r\n.logo-container {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    width: 100%;\r\n    padding: 10px 0px;\r\n    img {\r\n        height: 3rem !important;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
